import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-user-create',
  template: `
    <div class="row">
      <div class="col-sm-12 offset-sm-0 col-lg-8 offset-lg-3 mt-5">
        <div class="row mb-4">
          <div class="col-md-5">
            <h1>Perfil</h1>
            <p>Configura la información de tu cuenta.</p>
          </div>
          <div class="col-md-7 mt-4 text-end">
            <!-- button class="btn btn-primary btn-lg rounded-5" routerLink="/services/service">Agregar usuario</!-->
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="card border-0 rounded-4 shadow">
              <div class="card-body p-4">
                <div class="row">
                  <div class="col-md-12">
                  <app-form-user [user]="user" [roles]="roles" (updateUser)="saveUser($event)"></app-form-user>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> 
    </div>
  `,
  styleUrls: []
})
export class UserCreateComponent implements OnInit {
  userId: number = 0;
  user: any = {};
  roles: any = [];

  constructor(
    private route: Router,
    private activateRoute: ActivatedRoute,
    private fb: FormBuilder,
    private toastr: ToastrService
  ) { 
    this.activateRoute.params.subscribe(params => {
      this.userId = params['id'];
      this.loadUser(this.userId);
    });

    // this.store.getRoles().subscribe({
      // next: (data: any) => {
        // this.roles = data;
      // },
      // error: (error: any) => {}
    // });
  }
  
  ngOnInit(): void {}

  loadUser(id: number) {
    
  }

  saveUser(user: any) {
    // this.store.createUser(user).subscribe({
      // next: (data: any) => {
        // this.toastr.success('Éxito', 'Usuario actualizado correctamente.');
      // },
      // error: (error: any) => {
        // this.toastr.error('Error', 'Ocurrió un error al actualizar el usuario');
      // }
    // });
  }
}
